import { IonIcon, IonLabel } from "@ionic/react";
import React from "react";
import { addCircleOutline as addIcon } from "ionicons/icons";
import clsx from "clsx";

import NewCategoryForm from "../NewCategoryForm";
import { ICategory } from "../../state";
import {
  editCategoriesPath,
  CREATE_CATEGORY_SUCCESS_MESSAGE,
} from "../../store/student";

import styles from "./CategoryForm.module.scss";

export interface CategoryFormProps {
  pathname: string;
  success_message: string;
  isOpen: boolean;
  categories: ICategory[];
  calling?: boolean;
  selectedCategoryIDs?: number[];
  update: (args: { [key: string]: any }) => void;
  createCategory(category: { name: string; color: string }): void;
}

const CategoryForm = (props: CategoryFormProps) => {
  const [state, setState] = React.useState({
    showNewCategoryForm: false,
    displayName: "",
    isCreatedNewCategory: false,
  });
  const update = (args: { [key: string]: any }) => {
    setState(prevState => ({ ...prevState, ...args }));
  };

  const displayCategories = React.useMemo(
    () => props.categories.filter(c => c.id > 0),
    [props.categories],
  );

  React.useEffect(() => {
    if (
      props.pathname !== editCategoriesPath &&
      props.success_message === CREATE_CATEGORY_SUCCESS_MESSAGE
    ) {
      update({ isCreatedNewCategory: true });
    }
  }, [props.pathname, props.success_message]);

  React.useEffect(() => {
    if (state.isCreatedNewCategory) {
      const newCategoryId = props.categories[props.categories.length - 1]?.id;
      if (newCategoryId) {
        props.update({
          category_ids: [...(props.selectedCategoryIDs ?? []), newCategoryId],
        });
      }
      update({ isCreatedNewCategory: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.categories]);

  return (
    <div className={styles.wrapper}>
      <NewCategoryForm
        calling={props.calling}
        visible={state.showNewCategoryForm}
        update={update}
        values={state}
        createCategory={props.createCategory}
      />
      <div
        className={styles.header}
        onClick={() => {
          props.update({
            showCategoryForm: !props.isOpen,
            showSubmitForm: false,
            showShareForm: false,
            showBoxForm: false,
          });
        }}
      >
        <IonLabel color="light">活かし先</IonLabel>
        <IonIcon
          className={styles.addIcon}
          slot="end"
          icon={addIcon}
          onClick={() => {
            setState({ ...state, showNewCategoryForm: true });
          }}
        />
      </div>
      <div className={styles.inner}>
        <ul className={styles.list}>
          {displayCategories.map(category => {
            const categorySet = new Set(props.selectedCategoryIDs);
            return (
              <li
                key={category.id}
                className={clsx(
                  styles.item,
                  categorySet.has(category.id) && styles.isSelected,
                )}
                onClick={() => {
                  if (categorySet.has(category.id)) {
                    categorySet.delete(category.id);
                  } else {
                    categorySet.add(category.id);
                  }
                  props.update({
                    category_ids: Array.from(categorySet),
                  });
                }}
              >
                <span
                  className={styles.colorBar}
                  style={{ backgroundColor: category.color }}
                />
                {category.name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default CategoryForm;
